import { SettingsContext } from '@contexts/SettingsContext/SettingsContext'
import { useContext } from 'react'

const useSettings = () => useContext(SettingsContext)

export default useSettings
